import { LOGO_DPI_QUALITY } from "@stadium/constants/logo";

const API_TIER_KEY_TO_QUALITY = {
  good: LOGO_DPI_QUALITY.GOOD,
  ok: LOGO_DPI_QUALITY.OK,
  poor: LOGO_DPI_QUALITY.POOR,
};

const normalizeDpiQualityTiersFromApi = (apiTiers) => {
  if (!apiTiers) return null;

  const tiers = Object.entries(apiTiers).reduce((acc, [key, tier]) => {
    const quality = API_TIER_KEY_TO_QUALITY[key.toLowerCase()];

    if (quality && tier) {
      acc[quality] = { min: tier.min ?? 0, max: tier.max ?? undefined };
    }

    return acc;
  }, {});

  return Object.keys(tiers).length === 3 ? tiers : null;
};

const normalizePrintAreaConfigFromApi = (printAreaConfig) => {
  if (!printAreaConfig) return null;

  const standardPrintWidthInches =
    printAreaConfig.standardPrintWidthInches ?? printAreaConfig.standard_print_width_inches;
  const standardPrintHeightInches =
    printAreaConfig.standardPrintHeightInches ?? printAreaConfig.standard_print_height_inches;

  if (!standardPrintWidthInches || !standardPrintHeightInches) return null;

  return { standardPrintWidthInches, standardPrintHeightInches };
};

export const isLogoDpiConfigReady = (logoDpiConfig) =>
  Boolean(
    logoDpiConfig?.standardPrintWidthInches &&
      logoDpiConfig?.standardPrintHeightInches &&
      logoDpiConfig?.dpiQualityTiers,
  );

export const getProductLogoDpiConfigFromProduct = (product) => {
  if (!product) return null;

  const productOverrides = {
    ...(normalizeDpiQualityTiersFromApi(product.dpiQualityTiers) && {
      dpiQualityTiers: product.dpiQualityTiers,
    }),
    ...(normalizePrintAreaConfigFromApi(product.printAreaConfig) && {
      printAreaConfig: product.printAreaConfig,
    }),
  };

  return Object.keys(productOverrides).length ? productOverrides : null;
};

export const getLogoDpiConfigFromApi = (config = {}, productOverrides = null) => {
  const {
    standardPrintWidthInches,
    standardPrintHeightInches,
    dpiQualityTiers: configTiers,
    printAreaConfig: legacyProductPrintArea,
  } = config;

  const productDpiTiers = productOverrides?.dpiQualityTiers;
  const productPrintAreaConfig =
    productOverrides?.printAreaConfig ?? legacyProductPrintArea ?? null;

  const productPrintArea = normalizePrintAreaConfigFromApi(productPrintAreaConfig);
  const resolvedStandardPrintWidthInches =
    productPrintArea?.standardPrintWidthInches ?? standardPrintWidthInches;
  const resolvedStandardPrintHeightInches =
    productPrintArea?.standardPrintHeightInches ?? standardPrintHeightInches;

  const dpiQualityTiers =
    normalizeDpiQualityTiersFromApi(productDpiTiers) ??
    normalizeDpiQualityTiersFromApi(configTiers);

  if (!resolvedStandardPrintWidthInches || !resolvedStandardPrintHeightInches || !dpiQualityTiers) {
    return null;
  }

  return {
    standardPrintWidthInches: resolvedStandardPrintWidthInches,
    standardPrintHeightInches: resolvedStandardPrintHeightInches,
    dpiQualityTiers,
  };
};
